module.exports = __webpack_public_path__ + "img/pobuilder.ce4c3e92.png";